export default () => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
};

const handleScroll = () => {
    const items = document.querySelectorAll('.image--lock');

    items.forEach((el) => {
        const rect = el.getBoundingClientRect();

        if (rect.top > 0) {
            el.style.setProperty('--position', 'absolute');
            el.style.setProperty('--progress', '100%');
        } else {
            el.style.setProperty('--position', 'fixed');
            el.style.setProperty(
                '--progress',
                `${Math.max(((el.offsetHeight + rect.top) / el.offsetHeight) * 100, 0)}%`
            );
        }
    });
};
